import { EventEmitter } from '@angular/core';

export interface DataTableConfig {
  codSistema: string;
  codNegocio?: string;
  codProducto?: string;
  page: number;
  pageSize: number;
  sortField: string;
  sortDirection: string;
  search?: string;
  columnConfig: ColumnConfig[];
  idTransaccion?: number;
}

export interface ColumnConfig {
  title: string; // Titulo que sera mostrado en el header
  property: string; // Clava para obtener el valor de la columna
  sortable: boolean; // Si se puede ordenar por esta columna
  sortField?: string;
  linkeable?: boolean;
  filterDate?: boolean;
  filterIcon?: boolean;
    // Maps the column value to a display value 
    // (i.e.show user status '001' as 'Active')
  displayMapping?: (val: any) => any;
};

export type ActionButtons = ActionButton[];

export interface ActionButton extends TableIcon {
  actionId: string | number;
}

export interface TableIcon {
  iconClass: string;
  tooltip?: string;
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/model/interfaces/dataTable.interface.ts